import React from 'react';

// Read-only list of items (e.g., current sprint)
const ActionPlanList = ({ title, items }) => {
  return (
    <div className="space-y-2">
      {title && <h3 className="text-lg font-semibold">{title}</h3>}
      {(!items || items.length === 0) && (
        <div className="text-sm opacity-70">No items to show.</div>
      )}
      {(items || []).map((item) => (
        <div key={item.id} className="border p-3 rounded flex items-start justify-between gap-3">
          <div>
            <div className="font-medium">{item?.task_template?.title}</div>
            <div className="text-sm opacity-80">{item?.task_template?.description}</div>
            <div className="text-xs opacity-70">CEPA: {item.cepa_category} • Type: {item?.task_template?.completion_type}</div>
          </div>
          <div className="text-xs">Status: {item.status}</div>
        </div>
      ))}
    </div>
  );
};

export default ActionPlanList;


